import { render, staticRenderFns } from "./SundryCreditorItems.vue?vue&type=template&id=6ba5c8cf&scoped=true"
import script from "./SundryCreditorItems.vue?vue&type=script&lang=js"
export * from "./SundryCreditorItems.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorItems.vue?vue&type=style&index=0&id=6ba5c8cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5c8cf",
  null
  
)

export default component.exports